import RIOButton, { type BUTTON_SIZE, type BUTTON_STYLE, type BUTTON_VARIANT } from '@rio-cloud/rio-uikit/Button';
import type { PropsWithChildren } from 'react';

import type { PropsWithTestId } from '../types';

interface IconButtonProps {
    onClick?: () => void;
    variant?: BUTTON_VARIANT;
    size?: BUTTON_SIZE;
    style?: BUTTON_STYLE;
    disabled?: boolean;
    className?: string;
    type?: 'button' | 'submit';
    dark?: boolean;
    'aria-label'?: string;
    'data-testid'?: string;
}

/**
 * The IconButton component is used for actions or links in a page. It only displays an icon and no additional label.
 * It's a wrapper around the Button component from rio-uikit
 */
const IconButton = ({
    onClick,
    variant,
    size,
    style,
    className,
    disabled,
    type,
    dark,
    children,
    'aria-label': ariaLabel,
    'data-testid': dataTestId,
}: PropsWithTestId<PropsWithChildren<IconButtonProps>>) => (
    <RIOButton
        aria-label={ariaLabel}
        data-testid={dataTestId}
        onClick={onClick}
        variant={variant}
        bsSize={size}
        bsStyle={style}
        disabled={disabled}
        className={`btn-icon-only ${className} ${dark && 'border-none bg-gray-darker text-gray-light outline-none hover:bg-gray-darkest active:bg-black'}`}
        type={type}
    >
        {children}
    </RIOButton>
);

export default IconButton;
